// removed by extract-text-webpack-plugin
module.exports = {"Sidedrawer":"sidedrawer__Sidedrawer__2INQl","open":"sidedrawer__open__2ZSLC","close":"sidedrawer__close___BDqH","Nav":"sidedrawer__Nav__1g5A7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidedrawer/sidedrawer.css
// module id = 112
// module chunks = 3